<template>
  <div class="d-flex justify-space-between w-100 flex-column h-100">
    <div>
      <div class="ion-padding-bottom d-flex w-100 align-center">
        <slot name="prepend" />

        <p class="font-md bold-medium blue-darker pl-xs">{{ t('documents.idDocument') }}</p>
      </div>
      <p class="subtitle grey ion-padding-bottom align-start">
        {{ t('documents.description') }}
      </p>

      <div class="costs-list">
        <div class="block bg-white w-100">
          <ion-row class="ba-grey pa-sm border-default">
            <ion-col size="12" class="ion-no-padding">
              <ion-button
                @click="$emit('add-document')"
                color="grey"
                fill="clear"
                expand="block"
                size="default"
              >
                <ion-icon :icon="addCircle" class="ion-margin-end"></ion-icon>
                {{ t('documents.addId') }}
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row class="ba-grey pa-sm border-default">
            <ion-col
              v-for="document in getAnswered()"
              :key="`document-${document.id}`"
              size="12"
              class="ion-no-padding d-flex document-card pa-sm"
            >
              <img class="border-default" :src="getCoverFile(document)" />
              <div class="pl-xs">
                <p class="font-sm">{{ t('profile.document.' + document.name) }}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>

    <div class="d-flex justify-space-between mt-xs">
      <ion-row class="w-100">
        <ion-col size="6"> </ion-col>
        <ion-col size="6">
          <ion-button
            fill="solid"
            expand="block"
            size="default"
            color="primary"
            class="text-lg text-weight-bold"
            @click="$emit('continue')"
          >
            {{ t('actions.confirm') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n';
  import { addCircle } from 'ionicons/icons';
  import { IonButton, IonCol, IonIcon, IonRow } from '@ionic/vue';
  import { storeToRefs } from 'pinia';
  import { useProfileStore } from '@/stores/profile-store';
  import { IDocument } from '@/interfaces/profile/profile-document.interface';

  const { t } = useI18n();
  defineEmits(['continue', 'back', 'add-document']);
  const { documents } = storeToRefs(useProfileStore());

  defineProps({
    hideReturn: {
      type: Boolean,
      default: false,
    },
  });

  const getCoverFile = (document: IDocument) => {
    const file = document.Inputs.filter((input) => input.type === 'file');

    return file[0] && file[0].Answers[0] ? file[0].Answers[0].value : '';
  };

  const getAnswered = () => {
    return documents.value.filter((item) =>
      item.Inputs.some((input) => input.type === 'file' && input.Answers.length > 0),
    );
  };
</script>

<style lang="scss" scoped>
  .document-card {
    img {
      width: 44px;
      object-fit: cover;
      height: 44px;
    }
  }

  .align-start {
    text-align: start;
  }
</style>
